import * as Yup from 'yup'

export const InviteWorkersViaLinkSchema = Yup.object().shape({
  collectDataTemplateId: Yup.string().required('Onboarding template is required'),
  partnerMarketId: Yup.string().required('Market is required'),
})
